import { api } from "common"

export const SUPPORT_URL = {
  getSupport: `${api.withAPI}api/support`,
  closeSupport: (_id: string) => `${api.withAPI}api/support/${_id}/close`,
}
